// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"936":"2667a4071e832c53","1221":"080ae3e4e94dcdf4","4937":"1901d605f18ed2d0","7547":"f930955b5f9540da","8486":"58180e4d90c66264"}[chunkId] + ".css";
};